const Header = () => {
  return <div className='header'>News Bulgaria</div>
}
export default Header
